import React from "react";
import { useNavigate } from "react-router-dom";

interface ErrorDisplayProps {
  message: string;
  retryAction?: () => void;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  message,
  retryAction,
}) => {
  const navigate = useNavigate();

  return (
    <div className="error-display">
      <div className="error-icon">
        <i className="bi bi-exclamation-triangle-fill"></i>
      </div>
      <h2>Something went wrong</h2>
      <p>{message}</p>
      <div className="error-actions">
        {retryAction && (
          <button className="retry-button" onClick={retryAction}>
            <i className="bi bi-arrow-clockwise"></i> Try Again
          </button>
        )}
        <button className="home-button" onClick={() => navigate("/")}>
          <i className="bi bi-house-door"></i> Go to Home Screen
        </button>
      </div>
    </div>
  );
};

export default ErrorDisplay;
